import React, { useEffect, useMemo, useState } from 'react';
import Icon from './icons/Icon';
import StarRating from './icons/StarRating';
import { getPageContent } from '../services/pageContentService';
import './Testimonials.css';

const DEFAULT_TESTIMONIALS = {
  subtitle: 'Testimonials',
  title: 'What Our Patients Say',
  description: "Don't just take our word for it. Read what our satisfied patients have to say about their experience with our dental care.",
  items: [
    { name: 'Amina Hassan', feedback: 'Dr. Muyabin explained every step clearly and made me feel at ease. Highly recommend!', rating: 5, role: 'Patient, Kinondoni' },
    { name: 'James Mwangi', feedback: 'Excellent orthodontic consultation. Modern equipment and friendly staff.', rating: 5, role: 'Patient, Masaki' },
    { name: 'Grace Mbelwa', feedback: 'Painless cleaning and whitening — best dental experience I have had.', rating: 5, role: 'Patient, Oyster Bay' },
  ],
};

const Testimonials = ({ hideHeader = false }) => {
  const [cms, setCms] = useState(null);

  useEffect(() => {
    let isMounted = true;
    (async () => {
      try {
        const data = await getPageContent('home', 'testimonials');
        if (!isMounted) return;
        if (data) {
          const items = Array.isArray(data.items)
            ? data.items.filter((x) => x && x.enabled !== false && x.name && x.feedback)
            : [];
          setCms({
            subtitle: data.subtitle || DEFAULT_TESTIMONIALS.subtitle,
            title: data.title || DEFAULT_TESTIMONIALS.title,
            description: data.description || DEFAULT_TESTIMONIALS.description,
            items: items.length ? items.map((x) => ({
              name: x.name,
              feedback: x.feedback,
              rating: Number(x.rating) || 5,
              role: x.role || 'Patient',
            })) : DEFAULT_TESTIMONIALS.items,
          });
        } else {
          setCms(DEFAULT_TESTIMONIALS);
        }
      } catch {
        if (isMounted) setCms(DEFAULT_TESTIMONIALS);
      }
    })();
    return () => { isMounted = false; };
  }, []);

  const content = cms || DEFAULT_TESTIMONIALS;

  return (
    <section className={`testimonials-section ${hideHeader ? 'testimonials-section--embedded' : ''}`} id="testimonials">
      {!hideHeader && (
        <div className="testimonials-header">
          <span className="testimonials-subtitle section-eyebrow section-eyebrow--light">{content.subtitle}</span>
          <h2 className="testimonials-title">{content.title}</h2>
          <p className="testimonials-description">{content.description}</p>
        </div>
      )}

      <div className="testimonials-grid">
        {content.items.map((testimonial, index) => (
          <div key={index} className="testimonial-card">
            <div className="testimonial-quote">"</div>
            <div className="testimonial-rating">
              <StarRating count={testimonial.rating} size={16} />
            </div>
            <p className="testimonial-feedback">{testimonial.feedback}</p>
            <div className="testimonial-author">
              <div className="testimonial-avatar">
                <Icon name="user" size={24} />
              </div>
              <div className="testimonial-info">
                <h4>{testimonial.name}</h4>
                <p>{testimonial.role}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Testimonials;
